var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "movie-box f-3 fc-gray-2" }, [
    _c(
      "div",
      {
        staticClass:
          "movie-box-left as-flex flex-vertical main-center cross-center",
      },
      [
        _c("div", { staticClass: "title-row f-3" }, [
          _vm._v(_vm._s(_vm.movieInfo.title || "--")),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "type-row as-flex flex-horizontal main-start cross-center f-2",
          },
          [
            _c("div", { staticClass: "box-time" }, [
              _vm._v(
                _vm._s(_vm.movieInfo.launch || "--:--:--") +
                  " (" +
                  _vm._s(_vm.weekMapping[_vm.movieInfo.day] || "--:--:--") +
                  ")"
              ),
            ]),
            _vm._v(" "),
            _vm._l(_vm.movieInfo.tags || [], function (item, index) {
              return [
                _c(
                  "div",
                  {
                    key: item.id,
                    class: ["box-type", index === 0 ? "is-first" : ""],
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm.movieInfo.box !== "--" || _vm.movieInfo.first_week_box !== "--"
          ? _c(
              "div",
              {
                staticClass:
                  "box-row as-flex flex-horizontal main-start cross-center f-2",
              },
              [
                _c("div", { staticClass: "total-box" }, [
                  _vm._v("综合票房: " + _vm._s(_vm.movieInfo.box)),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "first-week-box" }, [
                  _vm._v("首周票房: " + _vm._s(_vm.movieInfo.first_week_box)),
                ]),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    !_vm.isTracking
      ? _c(
          "div",
          {
            staticClass:
              "movie-box-right as-flex main-around cross-center f-2 fc-gray-2",
          },
          [_vm._v("暂未监测(发起需求)")]
        )
      : _c(
          "div",
          {
            staticClass: "movie-box-right as-flex main-around cross-center f-2",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "awareness-box as-flex flex-vertical main-center cross-center",
              },
              [
                !_vm.isLatest
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "cycle as-flex flex-horizontal main-center cross-center",
                      },
                      [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.offsetMaaping[_vm.movieInfo.result.offset]
                            ) +
                            ")"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["0.0", "-1.0", "-2.0", "-3.0", "-4.0", "--"].includes(
                  _vm.movieInfo.result.offset
                )
                  ? _c("div", { staticClass: "tag1 f-3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.movieInfo.result.awareness.value !== "--"
                            ? _vm.movieInfo.result.awareness.value + "%"
                            : "--"
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.movieInfo.result.awareness.difference !== "--"
                  ? _c("div", { staticClass: "cycle" }, [
                      _vm._v("\n        较上周\n        "),
                      _c(
                        "span",
                        {
                          class: _vm.returnDiffColorClass(
                            _vm.movieInfo.result.awareness.difference
                          ),
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.returnFormatDiffValue(
                                _vm.movieInfo.result.awareness.difference
                              )
                            )
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "primary-box as-flex flex-vertical main-center cross-center",
              },
              [
                !_vm.isLatest
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "cycle as-flex flex-horizontal main-center cross-center",
                      },
                      [
                        _vm._v(
                          "(" +
                            _vm._s(
                              _vm.offsetMaaping[_vm.movieInfo.result.offset]
                            ) +
                            ")"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                ["0.0", "-1.0", "-2.0", "-3.0", "-4.0", "--"].includes(
                  _vm.movieInfo.result.offset
                )
                  ? _c("div", { staticClass: "tag1 f-3" }, [
                      _vm._v(
                        _vm._s(
                          _vm.movieInfo.result.primary.value !== "--"
                            ? _vm.movieInfo.result.primary.value + "%"
                            : "--"
                        )
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.movieInfo.result.primary.difference !== "--"
                  ? _c("div", { staticClass: "cycle" }, [
                      _vm._v("\n        较上周\n        "),
                      _c(
                        "span",
                        {
                          class: _vm.returnDiffColorClass(
                            _vm.movieInfo.result.primary.difference
                          ),
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.returnFormatDiffValue(
                                _vm.movieInfo.result.primary.difference
                              )
                            )
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }